// import { Translation } from "react-i18next";
import { useMediaQuery } from '@material-ui/core';
import i18n from '../i18n';

export const removeHTMLElement = (
  element: HTMLElement,
  property: string,
  startValue: any,
  endValue: any,
  time: number,
  callback: Function
) => {
  const frameRate = 0.06;
  let frame = 0;

  const delta = (endValue - startValue) / time / frameRate;
  const handle = setInterval(() => {
    ++frame;

    const value = (startValue + delta * frame).toFixed(2);
    if (element) {
      element.style[property] = parseFloat(value);
    }

    if (value == endValue) {
      clearInterval(handle);
      callback();
    }
  }, 1 / frameRate);
};

// export const translate = (key: string): JSX.Element => <Translation>{(t) => t(key)}</Translation>;
export const translate = (key: string, args: any = {}): string => i18n.t(key, args);

export const disableEvents = (e) => {
  e.stopPropagation();
  e.preventDefault();
};

export const withMediaQuery =
  (query, options?, ...args) =>
  (Component) =>
  (props) => {
    const mediaQuery = useMediaQuery(query, options);
    return <Component mediaQuery={mediaQuery} {...props} />;
  };

export const withMobileDetector = (Component) => (props) => {
  const mediaQuery = useMediaQuery('(max-width:960px)');
  return <Component isMobile={mediaQuery} {...props} />;
};

export const copyText = (text: string): boolean => {
  const textArea: any = document.createElement('textarea');
  textArea.style.position = 'fixed';
  textArea.style.top = 0;
  textArea.style.left = 0;
  textArea.style.width = '2em';
  textArea.style.height = '2em';
  textArea.style.padding = 0;
  textArea.style.border = 'none';
  textArea.style.outline = 'none';
  textArea.style.boxShadow = 'none';
  textArea.style.background = 'transparent';
  textArea.value = text;

  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();

  let isSuccess: boolean = false;
  try {
    document.execCommand('copy');
    isSuccess = true;
  } catch (err) {}

  document.body.removeChild(textArea);
  return isSuccess;
};

export const textLimitation = (text: string, limit: number = 100, rtl: boolean = false): string => {
  if (text === null) {
    return '';
  }

  if (text.length <= limit) {
    return text;
  }

  if (rtl) {
    const t = text.substring(text.length - limit);
    return `...${t}`;
  }

  const t = text.substring(0, limit);

  return `${t}...`;
};

export const generateTimeToolTip = (row, type) => {
  let value = 'Not insurance default time';

  switch (type) {
    case 'pickup':
      value =
        row.insurance_default_pickup_time !== row.pickup_time
          ? !row.insurance_default_pickup_time
            ? value
            : row.insurance_default_pickup_time
          : 'No change';
      break;

    case 'dropoff':
      value =
        row.insurance_default_dropoff_time !== row.dropoff_time
          ? !row.insurance_default_dropoff_time
            ? value
            : row.insurance_default_dropoff_time
          : 'No change';
      break;
  }

  return value;
};
